/**
 * @module app.prospection.wallet.lastBusinessCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function LastBusinessCtrl($scope, $uibModalInstance, $log) {
        var self = {};



        self.ok = function() {
            $uibModalInstance.close(true);
        };

        self.cancel = function() {
            $uibModalInstance.close(false);
        };

        return self;
    }

    LastBusinessCtrl.$inject = [
        '$scope',
        '$uibModalInstance',
        '$log'
    ];

    angular
        .module('app.prospection.wallet.lastBusinessCtrl', ['ui.bootstrap.modal'])
        .controller('LastBusinessCtrl', LastBusinessCtrl);
});
